// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"e01a9109","142":"29340f11","787":"d4aba7ab"}[chunkId] + ".chunk.js";
};